import { Picture } from 'shared_DEPRECATED/types/Picture';

import { ACTION_TYPES } from './config';
import { ReactionActionType, ReactionsType } from './types';

const reactionActions = {
  [ACTION_TYPES.ADD]: (
    reactions: ReactionsType,
    emoji: string,
    userInfo: {
      name: string;
      picture: Picture;
      email: string;
    }
  ) => {
    const reactionUsers = reactions[emoji] || [];
    return { ...reactions, [emoji]: [...reactionUsers, userInfo] };
  },
  [ACTION_TYPES.REMOVE]: (
    reactions: ReactionsType,
    emoji: string,
    userInfo: {
      name: string;
      picture: Picture;
      email: string;
    }
  ) => {
    const reactionsCopy = { ...reactions };
    const filteredUsers = reactions[emoji].filter(
      (user) => user.email !== userInfo.email
    );

    if (filteredUsers.length === 0) {
      delete reactionsCopy[emoji];
    } else {
      reactionsCopy[emoji] = filteredUsers;
    }

    return reactionsCopy;
  },
};

export const updateReactions = ({
  reactions,
  emoji,
  userInfo,
  type,
}: {
  reactions: ReactionsType;
  emoji: string;
  userInfo: {
    name: string;
    picture: Picture;
    email: string;
  };
  type: ReactionActionType;
}) => {
  return reactionActions[type](reactions, emoji, userInfo);
};
